import classNames from 'classnames'
import {Text} from 'quickstart/components/content/Text'
import {dataProps} from 'quickstart/theme'
import {ComponentProps, Fragment, ReactNode} from 'react'
import {Container} from '../Container'
import S from './styles.module.css'

type SectionProps = ComponentProps<'section'> & {
  as?: any
  bleed?: boolean
  heading?: ReactNode
  variant?: 'default' | 'skinny' | 'superskinny' | 'abutting'
}

const SectionHeading = (props: ComponentProps<typeof Text>) => (
  <Text
    variant="sectionHead"
    prose
    {...props}
    className={classNames(S['section-heading'], props.className)}
  />
)

const _Section = ({
  as = 'section',
  bleed = false,
  children,
  heading,
  variant = 'default',
  ...props
}: SectionProps) => {
  const AsComponent = as as 'section'

  if (heading && typeof heading === 'string') {
    heading = <SectionHeading>{heading}</SectionHeading>
  }

  const MaybeContainer = bleed ? Fragment : Container

  return (
    <AsComponent
      {...dataProps({variant})}
      {...props}
      className={classNames(S.section, props.className)}
    >
      <MaybeContainer>
        {heading}
        {children}
      </MaybeContainer>
    </AsComponent>
  )
}

export const Section = Object.assign(_Section, {Heading: SectionHeading})
